import { storyblokEditable } from '@storyblok/react';
import { motion } from 'framer-motion';
import { FC } from 'react';

import Container from '@/components/elements/Container';
import PreHeading from '@/components/elements/PreHeading';
import Prose from '@/components/elements/Prose';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';

export interface CompensationProps {
  blok: any;
  content: any;
}

function IncentiveRow({ incentive, compensation, index }) {
  return (
    <div
      className={`grid grid-cols-2 gap-2 ${
        index % 2 === 1 ? 'bg-theme-offwhite' : ''
      }`}
    >
      <div
        className={`${
          index % 2 === 1 ? 'border-r-[1px] border-l-0' : ''
        }  border-white justify-center px-4 py-2 md:py-4`}
      >
        <Prose
          size="xs"
          center={true}
          content={incentive}
          animate={false}
        ></Prose>
      </div>
      <div className="grid self-center px-4 py-2 md:py-4">
        <Prose
          size="xs"
          center={true}
          content={compensation}
          animate={false}
        ></Prose>
      </div>
    </div>
  );
}

const Compensation: FC<CompensationProps> = ({ blok }) => {
  return (
    <Section {...storyblokEditable(blok)} className="overflow-hidden">
      <Container size={'wider'} className="flex flex-col gap-12">
        <StandardText blok={blok} size={StandardTextSize.MD} />
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.35,
            },
          }}
          viewport={{ once: true, margin: '200px' }}
        >
          <div className="grid grid-cols-2 bg-theme-lightgrey">
            <div className="justify-center border-[1px] border-l-0 border-white px-4 py-2 md:py-4">
              <PreHeading size="xs" color="grey">
                Employee Incentives
              </PreHeading>
            </div>
            <div className="justify-center border-[1px] border-l-0 border-white px-4 py-2 md:py-4">
              <PreHeading size="xs" color="grey">
                Compensation Total
              </PreHeading>
            </div>
          </div>
          {blok.benefits.map((r, i) => (
            <IncentiveRow key={r._uid} {...r} index={i} />
          ))}
        </motion.div>
      </Container>
    </Section>
  );
};

export default Compensation;
